import SelectBaseAntd, { SelectBaseAntdProps } from "../SelectBaseAntd";
import useCnaes from "core/features/cnae/hooks/useCnaes";

export interface SelectCnaeProps<T = any> extends SelectBaseAntdProps<T> {
  value: any;
  onChange: (v: any) => void;
}

function SelectCnae({ value, onChange, ...rest }: SelectCnaeProps) {
  const { isLoading, data } = useCnaes();

  return (
    <SelectBaseAntd
      loading={isLoading}
      size="large"
      placeholder="Selecione"
      value={value}
      allowClear
      showSearch
      onChange={onChange}
      optionFilterProp="label"
      options={data?.map((item) => ({
        value: item.id,
        label: item.nome,
      }))}
      {...rest}
    />
  );
}

export default SelectCnae;
